<template>
  <el-dialog
    title="支付确认"
    :visible.sync="dialogVisible"
    width="500px"
    @close="handleClose"
  >
    <el-form
      ref="payForm"
      :model="formData"
      :rules="rules"
      label-width="120px"
      v-loading="loading"
    >
      <el-form-item label="订单ID">
        <el-input v-model="payInfo.order_id" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="订单金额">
        <el-input v-model="payInfo.amount" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="确认信息">
        <el-alert
          :title="payInfo.message"
          type="warning"
          :closable="false"
          show-icon
        >
        </el-alert>
      </el-form-item>

      <el-form-item label="确认支付" prop="confirm">
        <el-radio-group v-model="formData.confirm">
          <el-radio :label="true">确认标记为已支付</el-radio>
          <el-radio :label="false">取消操作</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button 
        type="primary" 
        @click="handleSubmit" 
        :loading="submitting"
        :disabled="!formData.confirm"
      >
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'PayConfirmDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      submitting: false,
      payInfo: {
        order_id: '',
        amount: '',
        message: ''
      },
      formData: {
        confirm: false
      },
      rules: {
        confirm: [
          { required: true, message: '请选择确认选项', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal && this.orderId) {
        this.loadFormData()
      }
    },
    dialogVisible(newVal) {
      if (!newVal) {
        this.$emit('update:visible', false)
      }
    }
  },
  methods: {
    async loadFormData() {
      if (!this.orderId) return
      
      this.loading = true
      try {
        const response = await axios.get(`${this.base_url}/orders/${this.orderId}/pay/form`)
        if (response.status === 200 && response.data.code) {
          const data = response.data.data
          this.payInfo = {
            order_id: data.order_id || '',
            amount: data.amount || '',
            message: data.message || '确认标记为已支付吗?'
          }
        } else {
          this.$message.error(response.data.message || '获取表单数据失败')
        }
      } catch (error) {
        console.error('获取表单数据失败:', error)
        this.$message.error('获取表单数据失败')
      } finally {
        this.loading = false
      }
    },

    async handleSubmit() {
      this.$refs.payForm.validate(async (valid) => {
        if (valid) {
          if (!this.formData.confirm) {
            this.$message.warning('请确认支付操作')
            return
          }
          
          this.submitting = true
          try {
            const response = await axios.post(`${this.base_url}/orders/${this.orderId}/pay/submit`, this.formData)
            if (response.status === 200 && response.data.code) {
              this.$message.success('支付确认成功')
              this.dialogVisible = false
              this.$emit('success')
            } else {
              this.$message.error(response.data.message || '支付确认失败')
            }
          } catch (error) {
            console.error('支付确认失败:', error)
            this.$message.error('支付确认失败')
          } finally {
            this.submitting = false
          }
        } else {
          this.$message.error('请检查表单填写是否正确')
        }
      })
    },

    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },

    resetForm() {
      this.$refs.payForm && this.$refs.payForm.resetFields()
      this.formData = {
        confirm: false
      }
      this.payInfo = {
        order_id: '',
        amount: '',
        message: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
}

.el-form {
  .el-select {
    width: 100%;
  }
}

.el-alert {
  margin-bottom: 10px;
}
</style>